import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import './BookstoreCategoryShare.scss';
import { Paper, Typography, LinearProgress, Grid } from '@material-ui/core';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList, CartesianGrid, Cell } from 'recharts';
import { Percentual, MoneyLessBRL } from '../../../../services';
import { QUERY_FILTER_BOOKSTORE, QueryFilter } from 'src/component/shared';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedBookstoreShare } from '../../../shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreCategoryShareProps {

}

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreCategoryShareState {
    dialogOpen: boolean,
    customFilter: {
        isChart: boolean
    },
    isUpdate: false,

}

export interface IBookstoreCategoryShareDataChart {
    category: string;
    billing: number;
    billing_label: string;
    percent_label: string;
    percent_result: number;
    color: string;
}

const COLORS = ['#FF6A14','#323232', '#65cc93', '#FFBB28', '#90EE90',
            '#FFB6C1', '#FFA07A', '#0088FE', '#87CEFA', '#778899', '#778899', '#B0C4DE',
            '#008080', '#D8BFD8', '#FF6347', '#40E0D0', '#EE82EE', '#00C49F','#20B2AA'];

const BOOKSTORE_SUBJECT_SHARE = gql`
query bookstoreCategoryShare($customFilter: BookstoreCustomFilter) {
  bookstoreCategoryShare(bookstoreCustomFilter: $customFilter) {
    category,
    billing,
    percent_label,
  }
}
`;

// statless component
const BookstoreCategoryShareDataChart = ({ data }: { data: IBookstoreCategoryShareDataChart[] }) => (

    <div>
    <ResponsiveContainer width="100%" height={370} >
        <BarChart
                data={data}
                margin={{ top: 10, right: 20, left: 100, bottom: 5 }}
                layout="vertical">
                <CartesianGrid vertical={false} horizontal={false} />
                <XAxis type="number" hide={true}/>
                <YAxis yAxisId="center" type="category" dataKey="category"  tick={{fontSize: '65%'}}/>
                <Tooltip content={<BookstoreCategoryShareTooltipData />} />
                <Bar stackId="a" yAxisId="center" dataKey="percent_result" barSize={25} isAnimationActive={false}>
                    {data.map((entry, index) => (
                        <Cell key={index} fill={entry.color}/>
                    ))}
                    <LabelList dataKey="percent_label" position="right" className="recharts-label-custom-black" />
                </Bar>
            </BarChart>
    </ResponsiveContainer>

    </div>

);

// statless component
const BookstoreCategoryShareTooltipData = (props: any) => {

    let content;
    props.payload !== null &&  props.payload.length !== undefined && props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (<div className="tooltip-box">
        <table>
            <tbody>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Assunto:</td><td className="tooltip-content">{content && content.category}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Share:</td><td className="tooltip-content">{content && content.percent_label}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Faturamento:</td><td className="tooltip-content">{content && content.billing_label}</td>
                </tr>
            </tbody>
        </table>
    </div>
    )
};

const dataFilled = (data: any) => {
    return data && data.bookstoreCategoryShare && !!data.bookstoreCategoryShare.length
}

export class BookstoreCategoryShare extends React.Component<IBookstoreCategoryShareProps, IBookstoreCategoryShareState> {
    constructor(props: IBookstoreCategoryShareProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          },
          dialogOpen: false,
          isUpdate: false,
    }
  }

  public render() {

    const jsonFilter = {
        "customFilter": {
            "isChart": this.state.customFilter.isChart,
            "limit": 10,
        }
    };

    return (<Query query={QUERY_FILTER_BOOKSTORE} notifyOnNetworkStatusChange={true}  >
        {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

            const productFilters = QueryFilter.getBookstoreProductFilter(clientC);
            const categoryFilters = QueryFilter.getBookstoreCategoryFilter(clientC);

            if ((productFilters != null && productFilters !== undefined && productFilters.length >= 1) || 
                (categoryFilters != null && categoryFilters !== undefined && categoryFilters.length >= 1)) {
                return null;
            }
            
            let dataCache = GetCacheIfExists('bookstore-data');
            const hasNoFilterAppliedBookstore = HasNoFilterAppliedBookstoreShare(clientC);

            if( hasNoFilterAppliedBookstore && dataCache != null && dataCache.bookstoreCategoryShare != null ) {
                return this.dataToRend(dataCache, false);
            } else {
                return (
                    <Query query={BOOKSTORE_SUBJECT_SHARE} variables={QueryFilter.getFilterBookstore(clientC, jsonFilter, [])}>
                        {({ loading, error, data, client }) => {

                            if ( hasNoFilterAppliedBookstore && data != null && data.bookstoreCategoryShare != null ) {
                                if(dataCache != null && dataCache !== undefined) {
                                    dataCache.bookstoreCategoryShare = data.bookstoreCategoryShare;
                                } else {
                                    dataCache = data;
                                }
                                SetDataToSession('bookstore-data', dataCache);
                            }

                            return (this.dataToRend(data, loading));
                        }}
                    </Query>
                );
            }

        }}
    </Query>)
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        return (
            <Grid item={true} xs={6} md={6}>
                <Paper className="publisher-sale-block panel-block" >
                    <Typography variant="headline" className="panel-title" component="title">
                        Share por Categoria
                    </Typography>
                    {
                        loading
                        ?
                        <LinearProgress />
                        :
                        (
                            dataFilled(data)
                            ?
                            (<BookstoreCategoryShareDataChart data={this.BookstoreCategoryShareDataChartMap(data.bookstoreCategoryShare)} />)
                            :
                            (<Typography variant="body2" className="comparative" component="p">
                                Não há informações de vendas
                            </Typography>)
                        )
                    }
                </Paper>
            </Grid>
        )
    }

    private BookstoreCategoryShareDataChartMap = (data: IBookstoreCategoryShareDataChart[]) => {

        const mappedData: IBookstoreCategoryShareDataChart[] = [];
        let colorAux = 0;
        data.forEach(e => {

            const item: IBookstoreCategoryShareDataChart = {
                billing: e.billing,
                billing_label: MoneyLessBRL(e.billing.toString()),
                category: e.category === null || e.category === undefined ? 'Outros' : e.category,
                color: COLORS[colorAux],
                percent_label: Percentual(e.percent_label.toString()),
                percent_result: Number(e.percent_label),
            };

            if (COLORS.length >= colorAux){
                colorAux = colorAux + 1;
            } else {
                colorAux = 0;
            } 

            mappedData.push(item);

        });

        return mappedData;
    }
}



// WEBPACK FOOTER //
// ./src/component/bookstore/sale/category-share/BookstoreCategoryShare.tsx